/* unplugin-vue-components disabled */import { render } from "./DailyInspectionDetail.vue?vue&type=template&id=50f8a286&scoped=true&ts=true"
import script from "./DailyInspectionDetail.vue?vue&type=script&lang=ts"
export * from "./DailyInspectionDetail.vue?vue&type=script&lang=ts"

import "./DailyInspectionDetail.vue?vue&type=style&index=0&id=50f8a286&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f8a286"]])

export default __exports__